import React, { useState, useEffect } from 'react';

const Typewriter = ({ words }) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    let timeout;

    const currentWord = words[currentWordIndex];
    const isDeletingState = isDeleting;

    if (isPaused) {
      timeout = setTimeout(() => setIsPaused(false), 1500);
      return () => clearTimeout(timeout);
    }

    if (!isDeletingState && displayText === currentWord) {
      setIsPaused(true);
      return;
    }

    if (isDeletingState && displayText === '') {
      setIsDeleting(false);
      setCurrentWordIndex((prev) => (prev + 1) % words.length);
      return;
    }

    const updateText = () => {
      if (!isDeletingState) {
        setDisplayText(currentWord.slice(0, displayText.length + 1));
      } else {
        setDisplayText(currentWord.slice(0, displayText.length - 1));
      }
    };

    const speed = isDeletingState ? 50 : 100;
    timeout = setTimeout(updateText, speed);

    return () => clearTimeout(timeout);
  }, [currentWordIndex, displayText, isDeleting, isPaused, words]);

  useEffect(() => {
    if (displayText === words[currentWordIndex] && !isPaused) {
      setTimeout(() => setIsDeleting(true), 1500);
    }
  }, [displayText, currentWordIndex, words, isPaused]);

  return <span className="text-cyan">{displayText}<span className="animate-pulse">|</span></span>;
};

export default Typewriter;
